import React from 'react'
import "./Yardages.css"
import { useStateValue } from "./StateProvider";
import { holes } from "./CourseInfo";

function Yardages() {
    return (
        <div className="yardages__info">
            <h3>Yardages</h3>
            <textarea className="disclaimer" rows="8" cols="50" readOnly value="This feature is presently a work in progress. 
                Green locations are being adjusted for accuracy. 
                Most are presently @ +/-4 yards.
                So far, this is the best acheivable with an iphone 8 and GoogleEarth.
                Accuracy reading is based on your device and its ability to acquire satellite signals.">
                </textarea>
            
        </div>
    )
}

export default Yardages
